import React from 'react';
import { Container } from '@mui/material';
import SectionTitle from '../sectionTitle';

export default function Section({ title, children }) {
  return (
    <Container
      maxWidth="lg"
      sx={{
        marginY: {
          xs: 20,
          md: 24,
          lg: 40,
        },
      }}
    >
      {title && <SectionTitle title={title} />}
      {children}
    </Container>
  );
}
